import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { t } from 'i18next';
import React from 'react';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import {
  MatchStyledText,
  StyledFlexWithGapAndNoWrap,
  TextAndViewLocationsContainer,
} from '../../SmartChoiceBreakDown.styles';
import { StyledButton } from '../BenfitsBreakDown.styles';

interface MatchTextWithTierLocationsProps {
  text: string;
  StartIcon?: React.ReactNode;
  EndIcon?: React.ReactNode;
  handleTabChange?: (tab: number, isAnalyticsEnabled?: boolean) => void;
  isCost?: boolean;
  isViewLink?: boolean;
}
export const MatchTextWithTierLocations = ({
  text,
  StartIcon,
  EndIcon,
  handleTabChange,
  isCost,
  isViewLink,
}: MatchTextWithTierLocationsProps) => (
  <StyledFlexWithGapAndNoWrap
    alignItems="flex-start"
    data-testid="match-text-Tier 1 provider"
    direction="row"
  >
    <StyledFlexWithGapAndNoWrap>
      <IconSymbol color="#007000" icon="done" />
      {StartIcon && <React.Fragment>{StartIcon}</React.Fragment>}
    </StyledFlexWithGapAndNoWrap>

    <TextAndViewLocationsContainer alignItems="flex-start" direction="column">
      <MatchStyledText>{text}</MatchStyledText>
      {isViewLink && (
        <StyledButton
          data-testid="view-locations-benifits"
          onClick={() => {
            adobeLinkTrackEvent({
              name: `View ${isCost ? 'Costs' : 'Locations'}`,
              location: 'Smart choice benefits breakdown',
            });
            handleTabChange?.(isCost ? 3 : 1, false);
          }}
          variant="text"
        >
          {t(`SMART_CHOICE.VIEW_${isCost ? 'COSTS' : 'LOCATIONS'}`)}
          <IconSymbol icon="chevron_right" size={16} />
        </StyledButton>
      )}

      {EndIcon && <React.Fragment>{EndIcon}</React.Fragment>}
    </TextAndViewLocationsContainer>
  </StyledFlexWithGapAndNoWrap>
);
